var filterLayoutClasses = '.js-flitzproduct-filters, .flitzproducts-filter-overlay-header, .flitzproducts-filter-overlay-buttons';

window.hideFilters = function(){
    $(filterLayoutClasses).removeClass('open');



    let scrollToPosition = $('#js-flitzproduct-wrapper').offset().top - 50;

    $('html, body').animate({
        scrollTop: scrollToPosition
    }, 1000, 'swing', () => {})

}

window.showFilters = function(){
    $(filterLayoutClasses).addClass('open');
}

$('body').on('click', '.js-filter-menu-hide', function(){
    window.hideFilters();
});

$('body').on('click', '.js-toggle-mobile-filter-menu', function(){
    window.showFilters();
});


